module.exports = __webpack_public_path__ + "img/03_no.753d73a4.svg";